import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

export const articleSlice = createSlice({
  name: 'article',
  initialState,
  reducers: {
    articlePush: (state, action) => {
      const element = action.payload;
      if (!state.includes(element)) {
        state.push(element);
      }
    },
  },
});

export const { articlePush } = articleSlice.actions;

/// ambil data media artikel
export const fetchArticles = async (created_at, uid) => (dispatch) => {
  const fetchCall =
    created_at && uid
      ? `${process.env.REACT_APP_URL}/content-article?page=1&created_at=${created_at}&uid=${uid}`
      : `${process.env.REACT_APP_URL}/content-article?page=1`;
  fetch(fetchCall)
    .then((res) => {
      return res.json();
    })
    .then((res) => {
      for (let i = 0; i < res.data.length; i++) {
        dispatch(articlePush(res.data[i]));
      }
    });
}

export const articlesStore = (state) => state.article;

export const articlesIsEmpty = (state) => state.article.length === 0;

export default articleSlice.reducer;
